/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_SupportInputs */

const en_admin_nav_support = /** @type {(inputs: Admin_Nav_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

/**
* | output |
* | --- |
* | "Support" |
*
* @param {Admin_Nav_SupportInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_nav_support = /** @type {((inputs?: Admin_Nav_SupportInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_SupportInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_nav_support(inputs)
});
export { admin_nav_support as "admin.nav.support" }